import { GetBootstrapConfigReply } from "@marketplace/myplace-connect/myplace_pb";

export const snakeToCamel = (str?: string) => {
  if (!str) return;
  return str.replace(/_([a-z])/g, (_, c) => c.toUpperCase());
};

const getStringFieldValue = (source?: object, fieldName?: string) => {
  if (!source || !fieldName) return;

  const value = (source as Record<string, unknown>)[fieldName];
  return typeof value === "string" ? value : undefined;
};

export const getAppDownloadPath = (bootstrapData?: GetBootstrapConfigReply) => {
  if (!bootstrapData)
    return {
      resourceDomain: undefined,
      iosUrl: undefined,
      androidUrl: undefined,
    };

  let iosUrl = bootstrapData?.iosApp?.appStoreUrl;
  let androidUrl = bootstrapData?.androidApp?.googleStoreUrl;

  const adrFieldName = snakeToCamel(bootstrapData?.androidApp?.primaryUrlName);
  const primaryAndroidUrl = getStringFieldValue(
    bootstrapData?.androidApp,
    adrFieldName,
  );
  if (primaryAndroidUrl) {
    androidUrl = primaryAndroidUrl;
  }

  const iosFieldName = snakeToCamel(bootstrapData?.iosApp?.primaryUrlName);
  const primaryIosUrl = getStringFieldValue(
    bootstrapData?.iosApp,
    iosFieldName,
  );
  if (primaryIosUrl) {
    iosUrl = primaryIosUrl;
  }

  return {
    resourceDomain: bootstrapData.resourceDomain,
    iosUrl,
    androidUrl,
  };
};
